// 先进先出队列
export default class Queue {
  constructor () {
    this.elements = []
    this.status = 'finnal'
  }
  push (element) {
    this.elements.push(element)
    if (this.status === 'finnal' && this.elements.length > 0) {
      this.excute()
    }
  }
  shift () {
    return this.elements.shift()
  }
  async excute () {
    if (this.elements.length <= 0) {
      this.status = 'finnal'
      return
    }
    this.status = 'excuting'
    const currentElement = this.shift()
    await currentElement.handler()
    this.excute()
  }
}
